{
  "documentTitle": "Fuel - PDA",
  "nav": {
    "changeBranch": "Change branch",
    "systems": "Systems"
  },
  "sidebar": {
    "title": "Sidebar",
    "description": "Navigation menu",
    "toggle": "Toggle sidebar",
    "toggleHint": "Toggle navigation (Ctrl/Cmd+B)"
  }
}
